import {
  createSellerRemoteLaunch,
  getSellerRemoteSession,
  listSellerRemoteHostMembers,
  listSellerRemoteHosts,
  setSellerRemoteHostMembers,
} from '../../../api/generated/scope-filtered/scope-filtered'
import type {
  RemoteSessionRead,
  SellerRemoteHostRead,
  SellerRemoteMemberRead,
} from '../../../api/generated/model'
import {
  requestLaunchVia,
  toRemoteAccessSafeError,
  type LaunchOutcome,
} from '../../admin/servers/remote-access-api'

// The seller's three Remote Access routes. Errors leave here in the same safe
// shape the Admin page uses, so a refusal never carries more than a code.

export async function listSellerServers(): Promise<SellerRemoteHostRead[]> {
  let response: Awaited<ReturnType<typeof listSellerRemoteHosts>>
  try {
    response = await listSellerRemoteHosts()
  } catch (error) {
    throw toRemoteAccessSafeError(error)
  }
  if (response.status !== 200) {
    throw toRemoteAccessSafeError({ status: response.status, problem: response.data })
  }
  return response.data.items
}

export function requestSellerLaunch(hostId: string, idempotencyKey: string): Promise<LaunchOutcome> {
  return requestLaunchVia(() => createSellerRemoteLaunch(hostId, {
    headers: { 'Idempotency-Key': idempotencyKey },
  }))
}

export async function readSellerSession(sessionId: string): Promise<RemoteSessionRead> {
  let response: Awaited<ReturnType<typeof getSellerRemoteSession>>
  try {
    response = await getSellerRemoteSession(sessionId)
  } catch (error) {
    throw toRemoteAccessSafeError(error)
  }
  if (response.status !== 200) {
    throw toRemoteAccessSafeError({ status: response.status, problem: response.data })
  }
  return response.data
}

export async function listSellerServerMembers(hostId: string): Promise<SellerRemoteMemberRead[]> {
  let response: Awaited<ReturnType<typeof listSellerRemoteHostMembers>>
  try {
    response = await listSellerRemoteHostMembers(hostId)
  } catch (error) {
    throw toRemoteAccessSafeError(error)
  }
  if (response.status !== 200) {
    throw toRemoteAccessSafeError({ status: response.status, problem: response.data })
  }
  return response.data.items
}

export async function saveSellerServerMembers(
  hostId: string,
  membershipIds: string[],
): Promise<SellerRemoteMemberRead[]> {
  let response: Awaited<ReturnType<typeof setSellerRemoteHostMembers>>
  try {
    response = await setSellerRemoteHostMembers(hostId, { membership_ids: membershipIds })
  } catch (error) {
    throw toRemoteAccessSafeError(error)
  }
  if (response.status !== 200) {
    throw toRemoteAccessSafeError({ status: response.status, problem: response.data })
  }
  return response.data.items
}
